import QueryString from "qs"
import http from "../index"
import {
    apiListNetwork,
    apiExportExcelTemplate,
    apiImportExcelTemplate,
    apiPackageDetail,
    apiPackageUpdate,
    apiPackageDelete,
    apiListNetworkRequest,
    apiPackageRequestUpdate,
    apiPackageRequestDetail,
    apiApprovePackageRequest,
    apiRejectPackageRequest,
    apiImportExcelTemplateNetwork,
    apiImportExcelPackagePrice,
    apiExportExcelTemplatePackagePrice,
    apiExportExcelTemplateUpdatePrice,
    apiImportExcelUpdatePrice
} from "./urls"
import { param } from "jquery"

const ListNetwork = params => http.get(apiListNetwork, { params })
const getNetworkExcelTemplate = () => http.get(apiExportExcelTemplate, {responseType: "blob"})
const postNetworkExcelTemplate = (body) => http.post(apiImportExcelTemplate, body)
const packageDetail = (id) => http.get(apiPackageDetail(id))
const packageUpdate = (id, body) => http.put(apiPackageUpdate(id), body)
const packageDelete = (params) => http.delete(apiPackageDelete,{ params })
const packageBrowse = (id, body) => http.put(`1.0/wsm/package/net/${id}/browse`, body)
const packageRefuse = (id, body) => http.put(`1.0/wsm/package/net/${id}/refuse`, body)
const listPackageRequest = (params) => http.get(apiListNetworkRequest,{params})
const packageRequestDetail = (id) => http.get(apiPackageRequestDetail(id))
const updatePackageRequest = (id, body) => http.put(apiPackageRequestUpdate(id), body)
const approvePackageRequest = (id) => http.put(apiApprovePackageRequest(id))
const rejectPackageRequest = (id) => http.put(apiRejectPackageRequest(id))
const importExcelTemplateNetwork = (body) => http.post(apiImportExcelTemplateNetwork, body)
const importExcelPackagePrice = (body) => http.post(apiImportExcelPackagePrice, body)
const exportExcelTempaltePackagePrice = (param) => http.get(apiExportExcelTemplatePackagePrice, { params: param, responseType: "blob" })
const exportExcelTempalteUpdatePrice = (param) => http.get(apiExportExcelTemplateUpdatePrice, { params: param, responseType: "blob" })
const importExcelUpdatePrice = (body) => http.post(apiImportExcelUpdatePrice, body)
const Network = {
    ListNetwork,
    getNetworkExcelTemplate,
    postNetworkExcelTemplate,
    packageDetail,
    packageUpdate,
    packageDelete,
    packageBrowse,
    packageRefuse,
    listPackageRequest,
    packageRequestDetail,
    updatePackageRequest,
    approvePackageRequest,
    rejectPackageRequest,
    importExcelTemplateNetwork,
    importExcelPackagePrice,
    exportExcelTempaltePackagePrice,
    exportExcelTempalteUpdatePrice,
    importExcelUpdatePrice
}
export default Network